export const format = phone => {
  console.log("Phone Format Requested", phone);
  var cleaned = ("" + phone).replace(/\D/g, "");
  var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    var resp = ["+1 ", "(", match[2], ") ", match[3], "-", match[4]].join("");
    console.log("Phone Format Response", resp);
    return resp;
  }
  return null;
};
